import Action from 'lib/interfaces/Action';

export type InvoiceActions = Action<
  InvoiceActionType.SetStripeInvoicePdfUrl,
  SetStripeInvoicePdfUrlPayload
>;

export enum InvoiceActionType {
  SetStripeInvoicePdfUrl = 'invoices/SET_STRIPE_INVOICE_PDF_URL',
}

interface SetStripeInvoicePdfUrlPayload {
  stripeInvoicePdfUrl: string;
}

export function setStripeInvoicePdfUrl(
  stripeInvoicePdfUrl: string,
): Action<InvoiceActionType.SetStripeInvoicePdfUrl, SetStripeInvoicePdfUrlPayload> {
  return {
    payload: {
      stripeInvoicePdfUrl,
    },
    type: InvoiceActionType.SetStripeInvoicePdfUrl,
  };
}
